import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StpService {
  private _URL = environment.api+'/api/stp/';
  constructor(
    private http: HttpClient
  ) { }

  /* Acciones */
  public getCompanyCLABE() {
    return this.http.post(this._URL+ 'getCompanyCLABE', {});
  }
  public sendAbono() {}
  public registraOrdenPago() {}

  /* Listados */
  public getCambioEstado() {}
  public getAbonos(filters?) {
    return this.http.post(this._URL+ 'abonos', filters);
  }
  public getOrdenesPago(filters?) {
    return this.http.post(this._URL+ 'ordenesPago', filters);
  }
  public sendOrdenPagoCacao(abono, monto) {
    return this.http.post(this._URL+ 'ordenPago/cacao', {
      abono: abono
    });
  }
  /**
   * 
   * @param monto 
   * @param clabe 
   * @param institucion 
   * @param concepto 
   * @param referenciaNumerica 
   * @returns 
   * registraOrdenesResponse {
   *  return,
   *  id, 
   *  descripcionError
   * }
   */
  public addRegistraOrdenPago(monto: number, clabe: string, institucion: number, concepto: string) {
    return this.http.post(this._URL+ 'ordenPago/add', {
      monto: monto ,
      clabe: clabe,
      institucion: institucion,
      concepto: concepto
    });
  }



}
